// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"22a52969","977":"412a76e5"}[chunkId] + ".chunk.js";
};